import { useAsyncExecutor } from "async-executor-hook";
import React, { useEffect, useState } from "react";

import { Authorization } from "../../common/AuthorizationCpt";
import icIconDetailAprovedReject from "../../images/ic_detail_aproved_third.svg";
import icIconDetail from "../../images/ic_detail_icon.svg";
import checkIcon from "../../images/icon_check.svg";
import checkIconGreen from "../../images/icon_check_green.svg";
import checkIconRed from "../../images/icon_check_red.svg";
import redCrossIcon from "../../images/icon_cross_red.svg";
import downloadIcon from "../../images/icon_download.svg";
import pdfIcon from "../../images/icon_pdf.svg";
import LoadingGray from "../../images/loading_gray.gif";
import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import {
  ApproveButton,
  RejectButton,
} from "../AdminDocumentManagement/AdminDocumentManagementSharedStyles";
import { ButtonGeneric } from "../AdminPaymentValidationSidebar/AdminPaymentValidationSidebarStyles";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import Sidebar from "../Sidebar/Sidebar";
import {
  ButtonsContainer,
  ButtonsContainerRed,
  Container,
  ContainerBetween,
  DivContainer,
  DivFlexCenter,
  DivRucConsigne,
  Paragraph,
  PdfContainer,
  PdfsContainer,
  SectionTitle,
  Subtitle,
  Title,
  TitleCreditLine,
} from "./AdminDocumentValidationSidebarStyles";
import { getErrorValueResponse } from "../../common/error/Error";

function AdminDocumentValidationSidebar(props) {
  const {
    sidebarInfo,
    documentTypeNumb,
    onOutsideClick,
    handleRejectionComment,
    handleAskForAction,
    typeDocument,
    setShowSidebarModal,
    setShowSidebarDetailAproveReject,
  } = props;

  const {
    consigneeName,
    agentName,
    documentType,
    additionalInfo,
    documents,
    ruc,
  } = sidebarInfo;
  const [messageError, updateMessageError] = useState("");
  const [loadingErrorSap, setLoadingErrorSap] = useState(false);

  const loadingStateSap = () => {
    setLoadingErrorSap(false);
  };

  const [showModalError, updateShowModalError] = useState(false);

  const handleDownload = (document) => {
    generateDownloadUrl(document).then((url) => {
      window.open(url, "_blank");
    });
  };

  const toggleGetModal = () => {
    updateShowModalError(!showModalError);
  };

  const getCreditLine = useAsyncExecutor(
    async (params: any) => {
      const paramsAgent = {
        invoice_id: params.invoice_id,
      };
      return await networkBackendRequest(
        `/invoices/credit/${params.invoice_id}/`,
        HTTP_METHODS.GET,
        paramsAgent
      ).then((resp) => resp.json());
    },
    {
      onError: (error) => {
        if (error.error_code === "SAP006") {
          setLoadingErrorSap(true);
        }
        const errorMessage = getErrorValueResponse(error);
        updateMessageError(errorMessage);
        toggleGetModal();
      },
    }
  );

  const getCreditLineExecute = getCreditLine.execute;
  useEffect(() => {
    if (
      sidebarInfo.paymentStatusOption === "pending_validation" &&
      (documentTypeNumb === "agent_importer" ||
        documentTypeNumb === "agent_cargo" ||
        documentTypeNumb === "third_party_agency")
    ) {
      const sidebarInf = sidebarInfo;
      const monst = sidebarInf.quotations.map(
        (quotation) => quotation.quotation_id
      );
      getCreditLineExecute({
        quotation_ids: monst,
        invoice_id: sidebarInf.id,
      });
    }
  }, [getCreditLineExecute, sidebarInfo, documentTypeNumb]);

  return (
    <Sidebar onOutsideClick={onOutsideClick}>
      {showModalError && messageError && (
        <ConfirmationModal
          message={messageError}
          onAccept={() => {
            toggleGetModal();
            loadingStateSap();
          }}
          title={`Atención`}
          toggleModal={() => {
            toggleGetModal();
            loadingStateSap();
          }}
        />
      )}
      <Container>
        <div>
          <Subtitle>{documentType.toUpperCase()}</Subtitle>
          <Title>{agentName}</Title>
          {documents.length > 0 && (
            <>
              <SectionTitle>Documentos Adjuntados</SectionTitle>
              <PdfsContainer>
                {documents.map((document, index) => (
                  <>
                    {document.length > 0 && (
                      <PdfContainer
                        key={index}
                        onClick={() => handleDownload(document)}
                      >
                        <div>
                          <img src={pdfIcon} alt="Pdf" />
                          <p>{document.slice(document.lastIndexOf("/") + 1)}</p>
                        </div>
                        <img src={downloadIcon} alt="Descargar" />
                      </PdfContainer>
                    )}
                  </>
                ))}
              </PdfsContainer>
            </>
          )}
          {additionalInfo ? (
            <>
              <SectionTitle>DESCARGO</SectionTitle>
              <Paragraph>{additionalInfo}</Paragraph>
            </>
          ) : null}

          <div>
            <DivFlexCenter>
              {getCreditLine.isLoading && (
                <img src={LoadingGray} className="icon" alt="Loading screen" />
              )}
            </DivFlexCenter>
            {sidebarInfo.payerRucOption &&
              sidebarInfo.paymentStatusOption !== "pending_validation" && (
                <React.Fragment>
                  <SectionTitle>Línea de crédito</SectionTitle>
                  <ContainerBetween>
                    <TitleCreditLine>{documentType}</TitleCreditLine>
                  </ContainerBetween>
                </React.Fragment>
              )}
            {getCreditLine.isSuccess && (
              <React.Fragment>
                <SectionTitle>Línea de crédito</SectionTitle>
                <ContainerBetween>
                  <TitleCreditLine>{documentType}</TitleCreditLine>
                  <img src={checkIconGreen} alt="Check" />
                </ContainerBetween>
              </React.Fragment>
            )}
            {getCreditLine.isError && (
              <React.Fragment>
                <SectionTitle>Línea de crédito</SectionTitle>
                <ContainerBetween>
                  <TitleCreditLine>{documentType}</TitleCreditLine>
                  <img
                    src={loadingErrorSap ? LoadingGray : checkIconRed}
                    className={`${
                      loadingErrorSap ? "icon-loading" : "icon-error"
                    }`}
                    alt="Error"
                  />
                </ContainerBetween>
              </React.Fragment>
            )}
            {sidebarInfo.payerRucOption && (
              <DivRucConsigne>
                <b style={{ marginRight: "0.5rem" }}>{ruc}</b>-
                <div style={{ marginLeft: "0.5rem" }}> {consigneeName}</div>
              </DivRucConsigne>
            )}
          </div>
        </div>
        <div>
          <div>
            {sidebarInfo.volantes && (
              <ButtonGeneric
                height="6.2rem"
                marginBottom="2.5rem"
                onClick={() => {
                  setShowSidebarModal(true);
                }}
              >
                <img src={icIconDetail} alt="Aspa" />
                <div style={{ marginLeft: "1.25rem" }}>Ver detalle</div>
              </ButtonGeneric>
            )}
          </div>
          {(sidebarInfo.status === "approved" ||
            sidebarInfo.status === "rejected") &&
            sidebarInfo.typeDocumentValidate === "third_party" && (
              <div>
                <ButtonGeneric
                  height="6.2rem"
                  marginBottom="2.5rem"
                  border="1px solid #88B13B"
                  color="#88B13B"
                  onClick={() => {
                    setShowSidebarDetailAproveReject(true);
                  }}
                >
                  <img src={icIconDetailAprovedReject} alt="Aspa" />
                  <div style={{ marginLeft: "1.25rem" }}>
                    {sidebarInfo.status === "approved"
                      ? "Detalle de Aprobación"
                      : "Detalle de Rechazo"}{" "}
                  </div>
                </ButtonGeneric>
              </div>
            )}

          <Authorization
            actions={[
              "invoice.update credit cargo agent and consignee",
              "invoice.get_invoice_estimate_cargo_agent_and_consignee",
              "dam.update_dam_senasa_admin",
              "dam.update_dam_electronic_mandate",
              "volante.update_volante_third_party_auth",
            ]}
          >
            {sidebarInfo.payerRucOption === "third_party_agency" ||
            sidebarInfo.payerRucOption === "cargo_agent" ||
            sidebarInfo.payerRucOption === "consignee" ? (
              <>
                {(sidebarInfo.paymentStatusOption === "pending_payment" ||
                  sidebarInfo.paymentStatusOption === "pending_validation") && (
                  <DivContainer>
                    <ButtonsContainer>
                      <ApproveButton
                        disabled={getCreditLine.isLoading || messageError}
                        onClick={() =>
                          handleAskForAction(
                            sidebarInfo,
                            typeDocument === "agent_importer" ||
                              typeDocument === "agent_cargo" ||
                              typeDocument === "third_party_agency"
                              ? "paid"
                              : "approved"
                          )
                        }
                      >
                        <img src={checkIcon} alt="Check" />
                        Aprobar
                      </ApproveButton>
                    </ButtonsContainer>
                    <ButtonsContainerRed>
                      <RejectButton
                        disabled={getCreditLine.isLoading}
                        style={{
                          opacity: `${getCreditLine.isLoading ? 0.3 : 1}`,
                        }}
                        onClick={() =>
                          handleRejectionComment(sidebarInfo, "rejected")
                        }
                      >
                        <img src={redCrossIcon} alt="Aspa" />
                        Rechazar
                      </RejectButton>
                    </ButtonsContainerRed>
                  </DivContainer>
                )}
              </>
            ) : (
              <>
                {(sidebarInfo.status === "reviewing" ||
                  sidebarInfo.status === "pending") && (
                  <DivContainer>
                    <ButtonsContainer>
                      <ApproveButton
                        disabled={getCreditLine.isLoading || messageError}
                        onClick={() =>
                          handleAskForAction(
                            sidebarInfo,
                            typeDocument === "agent_importer" ||
                              typeDocument === "agent_cargo" ||
                              typeDocument === "third_party_agency"
                              ? "paid"
                              : "approved"
                          )
                        }
                      >
                        <img src={checkIcon} alt="Check" />
                        Aprobar
                      </ApproveButton>
                    </ButtonsContainer>
                    <ButtonsContainerRed>
                      <RejectButton
                        disabled={getCreditLine.isLoading}
                        style={{
                          opacity: `${getCreditLine.isLoading ? 0.3 : 1}`,
                        }}
                        onClick={() =>
                          handleRejectionComment(sidebarInfo, "rejected")
                        }
                      >
                        <img src={redCrossIcon} alt="Aspa" />
                        Rechazar
                      </RejectButton>
                    </ButtonsContainerRed>
                  </DivContainer>
                )}
              </>
            )}
          </Authorization>
        </div>
      </Container>
    </Sidebar>
  );
}

export default AdminDocumentValidationSidebar;

function generateDownloadUrl(id) {
  return networkBackendRequest(
    "/files/presigned-download-url/",
    HTTP_METHODS.GET,
    {
      object_name: id,
    }
  )
    .then((response) => response.json())
    .then((response) => response.url);
}
